import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'as-button',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent implements OnInit {

@Input() type = "primary";
@Input() value;
@Input() minimal = false;
@Input() disabled = false;
@Input() size;
@Input() role;
@Input() custom: boolean = false;
@Input() backgroundColor;
  constructor() { }

  communicateClick(value){
    console.log(value)
  }

  ngOnInit() {


  }

}
